// sqft → total price
export const calculateTotalPrice = (sqftPrice, sizeSqft) => {
  const sqft = parseFloat(sizeSqft);
  const price = parseFloat(sqftPrice);

  if (!sqft || !price) return "";
  return (sqft * price).toFixed(2);
};

// total → sqft price
export const calculateSqftPrice = (totalPrice, sizeSqft) => {
  const sqft = parseFloat(sizeSqft);
  const total = parseFloat(totalPrice);

  if (!sqft || !total) return "";
  return (total / sqft).toFixed(2);
};
